<script>
import { Bar } from 'vue-chartjs';

export default {
  name: 'barChart',
  extends: Bar,
  props: {
    data: {
      type: Object,
      required: true,
    },
    options: {
      type: Object,
      default: () => ({
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          labels: {
            fontSize: 16,
            fontStyle: 'normal',
            fontFamily: 'Arial, sans-serif',
            padding: 20,
            boxWidth: 20,
            boxHeight: 20
          },
          position: 'right', // или 'bottom', 'left', 'right'
          align: 'center'
        }
      }),
    },
  },
  watch: {
    data() {
       this.renderChart(this.data, { ...this.options });
    }
  },
  data() {
    return ({
        ctx: document.getElementById('myChart')
      });
  },
  mounted() {

  },
};
</script>
